import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Category from './Category';
import InfoSection from './InfoSection';
import {CategoryWrapperStyled, OfferWrapper, IconWrapper, OfferTitle} from './Categories.style';
import {RestaurantClosedMessage} from './Category.style';
import {FormattedMessage} from 'react-intl';
import Promotions from '../Promotions/Promotions';
import {Promotion, PromotionContent} from '../Promotions/Promotions.style';
import {SpecialOfferIcon} from '../../containers/LightHomePage/SpecialOfferIcon';
import {ONLINE_ORDER_PERMANENTLY_DISABLED} from '../../constants/constant';

export class Categories extends PureComponent {
  render() {
    const {
      categories,
      meals,
      showMealModal,
      addItemStraightToBasket,
      restaurantModes,
      menuName,
      menuDescription,
      promotions,
      isOfflineMenu,
      appliedPromotions,
      handleShowDisabledMealModal,
      serverOffline,
      isTemplateLight,
      handleOpenPictureModal,
      restaurantCode
    } = this.props;

    const restaurantClosedMessage = (!restaurantModes.onlineOrdering || serverOffline) && !ONLINE_ORDER_PERMANENTLY_DISABLED[restaurantCode] &&
      <RestaurantClosedMessage>
        <FormattedMessage id="menu.restaurantClosedMessage" />
      </RestaurantClosedMessage>;
    const renderPromotionHeader = promotions && (promotions.menuPage || (promotions.message && promotions.message.length > 0)) && (
      <OfferWrapper>
        <IconWrapper>
          <SpecialOfferIcon />
        </IconWrapper>
        <OfferTitle isTemplateLight={isTemplateLight}>
          <FormattedMessage id="home.specialOffer" />
        </OfferTitle>
      </OfferWrapper>
    );
    const renderPromotions = promotions && (
      <div data-rw="menu-special-offer">
        {renderPromotionHeader}
        <Promotions
          promotions={promotions}
          page="menu"
        />
      </div>
    );

    const appliedVoucher = appliedPromotions && appliedPromotions.find(promotion => promotion.type === 'VOUCHER' && promotion.applied);
    const appliedVoucherBox = appliedVoucher &&
      <PromotionContent
        page="menu"
        showPromotionContent="true"
      >
        <Promotion>
          <FormattedMessage
            id="checkout.voucherAccepted"
            values={{value: appliedVoucher.code}}
          />
        </Promotion>
      </PromotionContent>;
    const renderInfoSection = menuDescription && InfoSection({menuName, menuDescription});

    return (
      <CategoryWrapperStyled
        class="menu-page__menu"
        data-rw="menu-page--menu-component"
      >
        {restaurantClosedMessage}
        {appliedVoucherBox}
        {renderPromotions}
        {renderInfoSection}
        {categories.map(category =>
          <Category
            key={category.name}
            category={category}
            meals={meals}
            showMealModal={showMealModal}
            handleShowDisabledMealModal={handleShowDisabledMealModal}
            addItemStraightToBasket={addItemStraightToBasket}
            restaurantModes={restaurantModes}
            isOfflineMenu={isOfflineMenu}
            serverOffline={serverOffline}
            isTemplateLight={isTemplateLight}
            handleOpenPictureModal={handleOpenPictureModal}
          />
        )}
      </CategoryWrapperStyled>
    );
  }
}

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
  meals: PropTypes.object.isRequired,
  showMealModal: PropTypes.func.isRequired,
  handleShowDisabledMealModal: PropTypes.func,
  addItemStraightToBasket: PropTypes.func.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  menuName: PropTypes.string.isRequired,
  menuDescription: PropTypes.string,
  promotions: PropTypes.object,
  isOfflineMenu: PropTypes.bool.isRequired,
  appliedPromotions: PropTypes.array,
  serverOffline: PropTypes.bool.isRequired,
  handleOpenPictureModal: PropTypes.func.isRequired,
  isTemplateLight: PropTypes.bool.isRequired,
  restaurantCode: PropTypes.string.isRequired
};

export default Categories;



// WEBPACK FOOTER //
// ./components/Categories/Categories.js